import { get, post } from "@readai/common/api";
import {
  GetDraftEmailsParams,
  GetDraftEmailsResponse,
  ScheduleDraftEmailsRequest,
  ScheduleDraftEmailsResponse,
} from "@readai/common/types";
import { Params, withQueryParamsUrl } from "@readai/common/utils";

export const scheduleDraftEmail = async (
  request: ScheduleDraftEmailsRequest,
): Promise<ScheduleDraftEmailsResponse> => {
  return post("/draft-emails/schedule", request, { withCreds: true });
};

export const getDraftEmail = async (
  request: GetDraftEmailsParams,
): Promise<GetDraftEmailsResponse> => {
  return get(
    withQueryParamsUrl("/draft-emails", request as unknown as Params),
    {
      withCreds: true,
    },
  );
};
